const gccsSettingsBillingEstimation = {
  template: require('./template.html'),
  controller: 'SettingsBillingEstimationController',
  controllerAs: 'settingsBillingEstimationCtrl'
};

angular.module('public.security-manager.settings')
  .component('gccsSettingsBillingEstimation', gccsSettingsBillingEstimation);
